import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { selectPossibleOrderStatuses } from '@/store/reducers/dictionaries/selectors';
import { AppState, BucketFileVm } from '@/types';

import { OrderMetricsReducerState, OrdersReducerState } from './types';

export const selectOrdersState = (state: AppState): OrdersReducerState => state.orders;

export const selectOrder = (state: AppState): OrdersReducerState['order'] => {
  return selectOrdersState(state).order;
};

export const selectOrderReadyToBeCreated = (state: AppState): boolean =>
  !(
    selectRequestStatus(state, 'dictionaries|fetchAdditionalContactTypes') ||
    selectRequestStatus(state, 'shippingAddresses|fetchShippingAddresses') ||
    selectRequestStatus(state, 'activities|fetchActivityDetailsData') ||
    selectRequestStatus(state, 'dictionaries|fetchDeliveryTypes') ||
    // TODO: when order creation will be redesigned - remove bucket request
    selectRequestStatus(state, 'buckets|fetchAttachmentsList') ||
    selectRequestStatus(state, 'opportunities|fetchAll') ||
    selectRequestStatus(state, 'products|fetchDesignToOrderEntries') ||
    selectRequestStatus(state, 'dictionaries|fetchProposalItems')
  );

export const selectOrderDetailsReadyToBeShown = (state: AppState): boolean =>
  !selectRequestStatus(state, 'orders|fetchOrder') &&
  selectPossibleOrderStatuses(state).length > 0 &&
  selectOrder(state) !== null;

export const selectCalculatedTax = (state: AppState): number | null => {
  if (selectRequestStatus(state, 'orders|calculateTax')) {
    return null;
  }

  return (selectOrdersState(state).tax || selectOrder(state)?.tax) ?? null;
};

export const selectCreatedOrderId = (state: AppState): string | null => {
  return selectOrdersState(state).createdOrderId;
};

export const selectBucketId = (state: AppState): string | null => {
  return selectOrdersState(state).order?.salesforceBucketId ?? null;
};

export const selectBucketFiles = (state: AppState): BucketFileVm[] => {
  return selectOrdersState(state).bucketFiles;
};

export const selectDeliveryDate = (state: AppState) => {
  return state.orders?.deliveryDate;
};

export const selectInstallDate = (state: AppState) => {
  return state.orders?.installDate;
};

export const selectRoofInstallCompleteIsLoading = (state: AppState): boolean => {
  return selectRequestStatus(state, 'orders|setRoofInstallComplete');
};

export const selectOrderMetricsData = (state: AppState): OrderMetricsReducerState => {
  return state.orderMetrics;
};
